module.exports = __webpack_public_path__ + "static/media/mobileBackground.969a3508.png";